// apiAdministrationMaster

import { apiAdministrationMaster } from './apiInstances';

// CHATBOT
export const postStartChatbotRound = (body) => apiAdministrationMaster.post('/v2/chats/new', body);
export const postChatbotQuestion = (body, id) =>
  apiAdministrationMaster.post(`/v2/chats/${id}/rounds/new`, body);
